import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import viewport from './viewport_reducer'
import tags from './tags_reducer'
import goals from './goals_reducer'
import tagReports from './tag_reports_reducer'
import teams from './teams_reducer'
import users from './users_reducer'
import timeEntries from './time_entries_reducer'
import recentTagCombos from './recent_tag_combos_reducer'
import recentTags from './recent_tags_reducer'
import runningTimeEntries from './running_time_entries_reducer'
import bootstrapped from './bootstrapped_reducer'
import profile from './profile_reducer'
import ui from './ui_reducer'
import customer from './customer_reducer'
import accounts from './accounts_reducer'
import { selectedTeamMembership, selectedTeamInvites } from './team_membership_reducer'
import currentInvite from './current_invite_reducer'

export const reducerMap = {
    viewport,
    tags,
    goals,
    tagReports,
    teams,
    users,
    timeEntries,
    recentTagCombos,
    recentTags,
    runningTimeEntries,
    bootstrapped,
    profile,
    selectedTeamMembership,
    selectedTeamInvites,
    ui,
    customer,
    accounts,
    router: routerReducer,
    currentInvite,
}
const appReducer = combineReducers(reducerMap)
const rootReducer = (state, action) => {
    if(action.type === 'RESET') {
        state = undefined
    }

    return appReducer(state, action)
}
export default rootReducer


// WEBPACK FOOTER //
// ./src/redux/reducers/root_reducer.js